const PREFIX = "actDraft:";

export function getActDraftKey(mode) {
  if (!mode) return null;
  return `${PREFIX}${mode}`;
}

export function loadActDraft(mode) {
  try {
    const key = getActDraftKey(mode);
    if (!key) return null;
    const raw = window.localStorage.getItem(key);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveActDraft(mode, value) {
  try {
    const key = getActDraftKey(mode);
    if (!key) return;
    window.localStorage.setItem(key, JSON.stringify(value ?? {}));
  } catch {
    // ignore quota / private mode
  }
}

export function clearActDraft(mode) {
  try {
    const key = getActDraftKey(mode);
    if (!key) return;
    window.localStorage.removeItem(key);
  } catch {
    // ignore
  }
}

